import { useWebWorkerFn } from '@vueuse/core'

export function usePolylineWorker() {
  const { workerFn } = useWebWorkerFn(
    (recordsStringified, interval, fieldsStringified) => {
      const dividePolyline = (records, interval, fields) => {
        const max_distance = interval * 20;

        const calculateDistance = (lat1, lon1, lat2, lon2) => {
          const R = 6371e3;
          const φ1 = (lat1 * Math.PI) / 180;
          const φ2 = (lat2 * Math.PI) / 180;
          const Δφ = ((lat2 - lat1) * Math.PI) / 180;
          const Δλ = ((lon2 - lon1) * Math.PI) / 180;

          const a =
            Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

          return R * c;
        };

        const linesArray = [];
        let lineArray = [];
        let lastPoint = null;

        for (let record of records) {
          if (record === 0) {
            linesArray.push([...lineArray]);
            lineArray = [];
            continue;
          }

          if (lastPoint === null) {
            lastPoint = [
              record[fields.latitudeKey],
              record[fields.longitudeKey],
              record[fields.timeKey],
            ];
            lineArray.push([...lastPoint]);
            continue;
          }

          const distance = calculateDistance(
            lastPoint[0],
            lastPoint[1],
            record[fields.latitudeKey],
            record[fields.longitudeKey]
          );

          if (distance > max_distance) {
            linesArray.push([...lineArray]);
            lineArray = [];
          }

          lastPoint = [
            record[fields.latitudeKey],
            record[fields.longitudeKey],
            record[fields.timeKey],
          ];
          lineArray.push([...lastPoint]);
        }

        if (lineArray.length > 1) {
          linesArray.push([...lineArray]);
        }

        const longestLine = linesArray.reduce((longest, current) =>
          current.length > longest.length ? current : longest
        , []);

        return longestLine;
      };

      const records = JSON.parse(recordsStringified);
      const fields = JSON.parse(fieldsStringified);
      return dividePolyline(records, interval, fields);
    },
    { timeout: 10000 }
  );

  return workerFn;
}
